'use strict';

import React, { Component } from 'react';
import $  from 'jquery';


class ProfileAboutItemPerso extends Component{
    state = {
            //Initiate Time for the chart
            UserInfoStatus: 'pmb-block',
            MenuUserInfoStatus: 'dropdown',
            pwdContent: 'pmbb-edit',
            editContent: 'pmbb-edit',
            error: '',
            styleError: {
                color: 'white'
            },
            address: '',
            city: '',
            country: '',
            phone: this.props.phone
        }
    showMenuUserInfo= (e) => {
        e.preventDefault();
        if (this.state.MenuUserInfoStatus === 'dropdown open') {
            this.setState({MenuUserInfoStatus: 'dropdown'});
        } else {
            this.setState({MenuUserInfoStatus: 'dropdown open'});
        }
    }
    showEditMenuUserInfo= (e) => {
        e.preventDefault();
        this.setState({MenuUserInfoStatus: 'dropdown', UserInfoStatus: 'pmb-block toggled', pwdContent: 'pmbb-view', editContent: 'pmbb-edit'});
    }
    closeUserInfo= (e) => {
        e.preventDefault();
        this.setState({MenuUserInfoStatus: 'dropdown', UserInfoStatus: 'pmb-block', editContent: 'pmbb-edit', pwdContent: 'pmbb-edit'});
    }
    saveUserInfo= (e) => {
        var methodName = "/saveUserInfo";
        e.preventDefault();
        //Collect Information And Send this information update to BackEnd

        var urlUserChangeInfo = "/user/change/info?phone=" + this.state.phone;

        this.serverRequestUser = $.get(urlUserChangeInfo, function(result) {

            console.log('[INFO],' + methodName + ',  reception front des données user ');
            console.log(result);

            try {
                if (result.error === 'OK') {
                    this.setState({MenuUserInfoStatus: 'dropdown', UserInfoStatus: 'pmb-block', editContent: 'pmbb-edit', pwdContent: 'pmbb-edit'});
                    this.props.reloadInfo();
                }
            } catch (e) {
                // les instructions utilisées pour gérer les
                // exceptions
                console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                console.log(e); // on transfère l'objet de l'exception à une méthode
                return;
            }

        }.bind(this));
    }
    checkPwdChange= (e) => {
        e.preventDefault();
        this.setState({checkPwd: e.target.value});
    }
    oldPwdChange= (e) => {
        e.preventDefault();
        this.setState({oldPwd: e.target.value});
    }
    newPwdChange= (e) => {
        e.preventDefault();
        this.setState({newPwd: e.target.value});
    }
    closeChangePwd= (e) => {
        e.preventDefault();
        this.setState({MenuUserInfoStatus: 'dropdown', UserInfoStatus: 'pmb-block', editContent: 'pmbb-edit', pwdContent: 'pmbb-edit'});
    }
    phoneChange= (e) => {
        e.preventDefault();
        this.setState({phone: e.target.value});
    }
    showEditMenuChangePwd= (e) => {
        e.preventDefault();
        this.setState({editContent: 'pmbb-view', pwdContent: 'pmbb-edit', MenuUserInfoStatus: 'dropdown', UserInfoStatus: 'pmb-block toggled'});
    }
    changePwd= (e) => {
        const methodName = "changePwd";
        e.preventDefault();
        if (this.state.oldPwd === '') {
            this.setState({
                error: 'Votre mot de passe actuel doit être renseigné',
                styleError: {
                    color: 'red'
                }
            });
            return;
        }

        var re = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/;
        if (!re.test(this.state.newPwd)) {
            this.setState({
                error: 'Le mot de passe doit contenir 8 caractéres dont un nombre, une mininuscule et une majuscule',
                styleError: {
                    color: 'red'
                }
            });
            return;
        }

        //Test Si mot de passe est egal à sa confirmation
        if (this.state.newPwd != this.state.checkPwd) {
            this.setState({
                error: 'Le nouveau mot de passe doit être identique avec celui de confirmation',
                styleError: {
                    color: 'red'
                }
            });
            return;
        }
        var urlBox = "/login/change/pwd?old=" + this.state.oldPwd + "&toNew=" + this.state.newPwd + "&toNewConfirm=" + this.state.checkPwd;

        var element = document.querySelector('meta[name="_csrf"]');
        var content = element && element.getAttribute("value");
        var csrf = content;

        this.serverRequestChgPwd = Request({
            uri: window.location.origin + '/login/change/pwd',
            method: 'PUT',
            json: true,
            body: {
                'old': this.state.oldPwd,
                'toNew': this.state.newPwd,
                'toNewConfirm': this.state.checkPwd
            },
            headers: {
                'X-CSRF-TOKEN': csrf
            }
        }, function(error, response, body) {
            console.log('[INFO],  reception front des données: ');
            console.log(body);
            try {
                if (body.error === 'OK') {
                    window.location.replace("/loginPage");
                } else {
                    this.setState({
                        error: body.error,
                        styleError: {
                            color: 'red'
                        }
                    });
                }
            } catch (e) {
                // les instructions utilisées pour gérer les
                // exceptions
                console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                console.log(e); // on transfère l'objet de l'exception à une méthode
                this.setState({
                    error: "Veuillez essayer plus tard",
                    styleError: {
                        color: 'red'
                    }
                });
                return;
            }

        }.bind(this));

        /*
        this.serverRequestChgPwd = $.get(urlBox, function(result) {

            console.log('[INFO],' + methodName + ',  reception front des données box ');
            console.log(result);

            try {
                if (result.error === 'OK') {
                    this.setState({MenuUserInfoStatus: 'dropdown', UserInfoStatus: 'pmb-block', editContent: 'pmbb-edit', pwdContent: 'pmbb-edit'});
                }else{
                  this.setState({
                      error: result.error,
                      styleError: {
                          color: 'red'
                      }
                  });
                }
            } catch (e) {
                // les instructions utilisées pour gérer les
                // exceptions
                console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                console.log(e); // on transfère l'objet de l'exception à une méthode
                this.setState({
                    error: "Veuillez essayer plus tard",
                    styleError: {
                        color: 'red'
                    }
                });
                return;
            }

        }.bind(this));
        */

    }
    componentWillUnmount() {
        try {
            this.serverRequestChgPwd.abort();
            this.serverRequestUser.abort();
        } catch (e) {
            console.log(e);
        }
    }
    render() {

        return (

            <div className={this.state.UserInfoStatus}>
                <div className="pmbb-header">
                    <h2>
                        <i className="zmdi zmdi-account m-r-5"></i>
                        Vos Informations</h2>

                    <ul className="actions">
                        <li className={this.state.MenuUserInfoStatus}>
                            <a href="#" data-toggle="dropdown" onClick={this.showMenuUserInfo}>
                                <i className="zmdi zmdi-more-vert"></i>
                            </a>
                            <ul className="dropdown-menu dropdown-menu-right">
                                <li>
                                    <a data-pmb-action="edit" href="#" onClick={this.showEditMenuUserInfo}>Edit</a>
                                </li>
                                <li>
                                    <a data-pmb-action="changepwd" href="#" onClick={this.showEditMenuChangePwd}>Change Password</a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
                <div className="pmbb-body p-l-30">
                    <div className="pmbb-view">
                        <dl className="dl-horizontal">
                            <dt>Mobile Phone</dt>
                            <dd>{this.props.phone}</dd>
                        </dl>
                        <dl className="dl-horizontal">
                            <dt>Email Address</dt>
                            <dd>{this.props.email}</dd>
                        </dl>
                    </div>

                    <div className={this.state.editContent}>
                        <dl className="dl-horizontal">
                            <dt className="p-t-10">Mobile Phone</dt>
                            <dd>
                                <div className="fg-line">
                                    <input type="text" className="form-control" placeholder={this.props.phone} value={this.state.phone} onChange={this.phoneChange}/>
                                </div>
                            </dd>
                        </dl>

                        <div className="m-t-30">
                            <button className="btn btn-primary btn-sm" onClick={this.saveUserInfo}>Save</button>
                            <button data-pmb-action="reset" className="btn btn-link btn-sm" onClick={this.closeUserInfo}>Cancel</button>
                        </div>
                    </div>
                    <div className={this.state.pwdContent}>

                        <dl className="dl-horizontal">
                            <dt className="p-t-50" style={this.state.styleError}>{this.state.error}</dt>
                            <dd>
                                <div className="fg-line"></div>
                            </dd>
                        </dl>
                        <dl className="dl-horizontal">
                            <dt className="p-t-10">Ancien mot de passe</dt>
                            <dd>
                                <div className="fg-line">
                                    <input type="password" className="form-control" value={this.state.oldPwd} onChange={this.oldPwdChange}/>
                                </div>
                            </dd>
                        </dl>
                        <dl className="dl-horizontal">
                            <dt className="p-t-10">Nouveau mot de passe</dt>
                            <dd>
                                <div className="fg-line">
                                    <input type="password" className="form-control" value={this.state.newPwd} onChange={this.newPwdChange}/>
                                </div>
                            </dd>
                        </dl>
                        <dl className="dl-horizontal">
                            <dt className="p-t-10">Vérification mot de passe</dt>
                            <dd>
                                <div className="fg-line">
                                    <input type="password" className="form-control" value={this.state.checkPwd} onChange={this.checkPwdChange}/>
                                </div>
                            </dd>
                        </dl>

                        <div className="m-t-30">
                            <button className="btn btn-primary btn-sm" onClick={this.changePwd}>Change Mot de Passe</button>
                            <button data-pmb-action="reset" className="btn btn-link btn-sm" onClick={this.closeUserInfo}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>

        )
    }
};
export default ProfileAboutItemPerso
//module.exports = ProfileAboutItemPerso;
